import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '..';
import {
  AcknowledgeHoleType,
  CustomerOverviewType,
  HoleDetailsData,
  HoleDetectionClassificationApiData,
  HoleDetectionsApiResponse,
  UpdateHoleDetectionType,
} from 'models/holeDetection';

export const HoleDetectionApi = createApi({
  reducerPath: 'holeDetectionApi',
  tagTypes: [
    'hole-detections',
    'hole-detection-history',
    'hole-details',
    'hole-detections-customer-list',
  ],
  baseQuery,
  endpoints: (builder) => ({
    getHoleDetections: builder.query<HoleDetectionsApiResponse, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['hole-detections'],
    }),

    getHoleDetectionImage: builder.query<Blob, string>({
      query: (url) => ({
        url: url,
        responseHandler: (response) => response.blob(),
      }),
    }),

    getHoleClassifications: builder.query<
      HoleDetectionClassificationApiData,
      string
    >({
      query: (url) => ({
        url,
      }),
    }),

    updateHoleDetection: builder.mutation<void, UpdateHoleDetectionType>({
      query: ({ url, ...otherBodyprops }) => ({
        url: url as string,
        method: 'POST',
        body: otherBodyprops,
      }),
      invalidatesTags: ['hole-detections', 'hole-detection-history'],
    }),

    getHoleHistory: builder.query<HoleDetectionsApiResponse, string>({
      query: (url) => ({
        url,
      }),
      providesTags: ['hole-detection-history'],
    }),
    getImageFromImagePath: builder.query<Blob, string>({
      query: (url) => ({
        url,
        responseHandler: (response) => response.blob(),
      }),
    }),

    getHoleDetails: builder.query<HoleDetailsData, string>({
      query: (url) => ({
        url,
      }),
      providesTags: (_result, _error, image_id) => [
        { type: 'hole-details', id: image_id },
      ],
    }),

    acknowledegeHole: builder.mutation<void, AcknowledgeHoleType>({
      query: ({ url }) => ({
        url,
        method: 'POST',
      }),
      invalidatesTags: () => [
        { type: 'hole-details' },
        'hole-detections-customer-list',
      ],
    }),
    getCustomerHoleDetections: builder.query<HoleDetectionsApiResponse, string>(
      {
        query: (url) => ({
          url,
        }),
        providesTags: ['hole-detections-customer-list'],
      },
    ),
    getRobotOverview: builder.query<CustomerOverviewType, string>({
      query: (url) => ({
        url,
      }),
    }),
  }),
});

export const {
  useGetHoleDetectionsQuery,
  useGetHoleDetectionImageQuery,
  useGetHoleClassificationsQuery,
  useUpdateHoleDetectionMutation,
  useGetHoleHistoryQuery,
  useGetImageFromImagePathQuery,
  useGetHoleDetailsQuery,
  useAcknowledegeHoleMutation,
  useGetCustomerHoleDetectionsQuery,
  useGetRobotOverviewQuery,
} = HoleDetectionApi;
